import { render, staticRenderFns } from "./CreatePresentationModal.vue?vue&type=template&id=9ecbb66e&"
import script from "./CreatePresentationModal.vue?vue&type=script&lang=ts&"
export * from "./CreatePresentationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports